/* eslint-disable no-use-before-define */
import { toast } from 'react-toastify';

import { changeTimeAction } from '../components/schedule/actions';

export const WS_CONNECTING = 'WS_CONNECTING';
export const WS_CONNECTED = 'WS_CONNECTED';
export const WS_DISCONNECTED = 'WS_DISCONNECTED';
export const WS_SET_USER = 'WS_SET_USER';
export const TARIFF_END = 'TARIFF_END';

let timeout = 250;
let countReconnect = 0;
let socket = null;
let connectInterval;
let forcedClose = true;

const { vpriemScheduleParams } = window;
const { token } = vpriemScheduleParams;

export const initWSAction = (WebSocket, typeView) => (dispatch) => {
    const ws = WebSocket;

    if (ws.userConnectionID === null) {
        ws.ws.onmessage = (e) => {
            const response = JSON.parse(e.data);
            const {
                action,
                connectionID,
                data
            } = response;

            switch (action) {
                case 'NO_AUTH':
                    disconnectWSAction(socket);
                    toast.error('❌ Приложение не авторизовано', {
                        position: 'top-right',
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: 0
                    });
                    break;
                case 'TARIFF_END':
                    disconnectWSAction(socket);
                    dispatch({ type: TARIFF_END });
                    break;
                case 'CONNECTED': {
                    dispatch(setUserWSAction(connectionID));
                    // dispatch(setScheduleAction(data, {
                    //     preload: response.preload,
                    //     date: response.date,
                    //     typeView: response.typeView
                    // }));
                    break;
                }
                default:
                    break;
            }
        };
    }

    if (ws.userConnectionID) {
        ws.ws.onmessage = (e) => {
            const response = JSON.parse(e.data);
            const {
                action,
                type,
                data,
                unsetData
            } = response;

            switch (action) {
                case 'GET_SCHEDULE':
                    // dispatch(setScheduleAction(data, {
                    //     preload: response.preload,
                    //     date: response.date,
                    //     typeView: response.typeView
                    // }));
                    break;
                case 'ANONYM_CREATE_WRITE_SCHEDULE': {
                    if (typeView.value === 2) {
                        // dispatch(changeCountTicketsAction(data.date_write, {
                        //     operation: '-',
                        //     countFreeTickets: true,
                        //     countTickets: false
                        // }));
                    } else {
                        dispatch({ type, payload: data });
                    }
                    break;
                }
                case 'ANONYM_CREATE_WRITE_SCHEDULE_ERROR': {
                    if (typeView.value !== 2) {
                        dispatch({ type, payload: data });
                        alert('Извините, на этот талон уже есть запись');
                    }
                    break;
                }
                case 'ANONYM_DELETE_WRITE_SCHEDULE': {
                    if (typeView.value === 2) {
                        // dispatch(changeCountTicketsAction(data.date_write, {
                        //     operation: '+',
                        //     countFreeTickets: true,
                        //     countTickets: false
                        // }));
                    } else {
                        dispatch({ type, payload: data });
                    }
                    break;
                }
                case 'ANONYM_CREATE_TICKET_SCHEDULE': {
                    dispatch(changeTimeAction());
                    if (typeView.value === 2) {
                        // dispatch(changeCountTicketsAction(data.date_ticket, {
                        //     operation: '+',
                        //     countFreeTickets: true,
                        //     countTickets: true
                        // }));
                    } else {
                        dispatch({ type, payload: data });
                    }
                    break;
                }
                case 'ANONYM_DELETE_TICKET_SCHEDULE': {
                    if (typeView.value === 2) {
                        // dispatch(changeCountTicketsAction(data.date_ticket, {
                        //     operation: '-',
                        //     countFreeTickets: true,
                        //     countTickets: true
                        // }));
                    } else {
                        dispatch({ type, payload: data });
                    }
                    break;
                }
                case 'ANONYM_DIVIDE_TICKET_SCHEDULE': {
                    if (typeView.value === 2) {
                        // dispatch(changeCountTicketsAction(data.originalTicket.dateTicket, {
                        //     operation: '+',
                        //     countFreeTickets: true,
                        //     countTickets: true
                        // }));
                    } else {
                        dispatch({ type, payload: data });
                    }
                    break;
                }
                case 'ANONYM_REMOVE_DIVIDE_TICKET_SCHEDULE': {
                    dispatch(changeTimeAction());
                    if (typeView.value === 2) {
                        // dispatch(changeCountTicketsAction(data.unsetData.dateTicket, {
                        //     operation: '-',
                        //     countFreeTickets: true,
                        //     countTickets: true
                        // }));
                    } else {
                        dispatch({ type, payload: data });
                    }
                    break;
                }
                case 'ANONYM_HIDE_TICKET_SCHEDULE': {
                    if (typeView.value === 2) {
                        // dispatch(changeCountTicketsAction(data.ticket.dateTicket, {
                        //     operation: '-',
                        //     countFreeTickets: true,
                        //     countTickets: true
                        // }));
                    } else {
                        dispatch({ type, payload: data });
                    }
                    break;
                }
                case 'ANONYM_OPEN_TICKET_SCHEDULE': {
                    dispatch(changeTimeAction());
                    if (typeView.value === 2) {
                        // dispatch(changeCountTicketsAction(data.ticket.dateTicket, {
                        //     operation: '+',
                        //     countFreeTickets: true,
                        //     countTickets: true
                        // }));
                    } else {
                        dispatch({ type, payload: data });
                    }
                    break;
                }
                case 'ANONYM_RETIME_TICKET_SCHEDULE': {
                    dispatch(changeTimeAction());
                    if (typeView.value !== 2) {
                        dispatch({ type, payload: data });
                    }
                    break;
                }
                case 'CREATING_WRITE_SCHEDULE':
                case 'EDITING_WRITE_SCHEDULE': {
                    if (typeView.value !== 2) {
                        dispatch({ type, payload: { data, unsetData } });
                    }
                    break;
                }
                case 'CURRENT_EDITING_WRITES_SCHEDULE': {
                    if (typeView.value !== 2) {
                        dispatch({ type: 'WS_CURRENT_EDITING_WRITES_SCHEDULE', payload: { data } });
                    }
                    break;
                }
                default:
                    break;
            }
        };
    }
};

export const connectWSAction = filter => (dispatch) => {
    dispatch({ type: WS_CONNECTING });
    forcedClose = false;

    const {
        date,
        speciality,
        filial,
        typeView,
        doctor
    } = filter;
    let wsURL = '';

    if (process.env.NODE_ENV === 'production') {
        wsURL = 'wss://app.vpriem.ru:8015'; // for prod
    } else {
        wsURL = 'ws://vpriem.local:8001'; // for dev local
    }

    const params = `?currentDate=${date.format('x')}&speciality=${speciality ? JSON.stringify(speciality) : speciality}&filial=${filial}&typeView=${typeView.value}&doctor=${doctor}&token=${token}`;
    socket = new WebSocket(`${wsURL}${params}`);

    socket.onopen = () => {
        dispatch({ type: WS_CONNECTED, payload: socket });

        timeout = 250;
        clearTimeout(connectInterval);

        if (countReconnect > 0) {
            toast.dismiss();
            toast.success('Соединение с сервером восстановлено.', {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: 0
            });
            countReconnect = 0;
        }
    };

    socket.onclose = () => {
        dispatch({ type: WS_DISCONNECTED });

        if (!forcedClose) {
            if (countReconnect === 0) {
                toast.error('🔄 Восстановление соединения с сервером.', {
                    position: 'top-right',
                    autoClose: false,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: 0
                });
            }

            timeout += timeout;
            countReconnect++;
            connectInterval = setTimeout(check(socket, dispatch), Math.min(10000, timeout));
        }
    };

    socket.onerror = () => {
        dispatch({ type: WS_DISCONNECTED });
        if (countReconnect === 0) {
            toast.error('⚠️ Нет соединения с сервером.', {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: 0
            });
        }

        socket.close();
    };
};

export const disconnectWSAction = (Socket) => {
    forcedClose = true;
    Socket.close();
};

export const setUserWSAction = connectionID => (dispatch) => {
    dispatch({ type: WS_SET_USER, payload: { connectionID, token } });
};

const check = (ws, dispatch) => {
    if (!ws || ws.readyState === WebSocket.CLOSED) dispatch(connectWSAction(window.vpriemScheduleParams));
};
